import React from 'react';

import { SearchInput, Button } from '../../../../../../../components';

import { useTranslate } from '../../../../../../../hooks';

function SearchEmpPortaMenuSeaction({ handleSearchTitle, openAddDesignation }) {
  const { translate } = useTranslate();

  return (
    <div className="flex gap-2">
      <SearchInput
        containerClassName={'w-full max-w-sm'}
        className={
          'w-full max-w-sm py-2 h-10 border-gray-800 border-opacity-25'
        }
        onChange={(e) => handleSearchTitle?.(e.target.value)}
      />

      <Button className="export-btn shrink-0 ml-auto h-10">
        {translate('Export All')}
        <i className="las la-file-export"></i>
      </Button>

      <Button
        className={`primary-btn gap-x-1 shrink-0 h-10`}
        onClick={openAddDesignation}
      >
        <i className="las la-plus" style={{ fontSize: '1.2rem' }}></i>
        {translate('Add Menu')}
      </Button>
    </div>
  );
}

export default SearchEmpPortaMenuSeaction;
